import { UIText1 } from '@cian/ui-kit';
import * as React from 'react';

export const ModalHeader = () => <UIText1>Информация из ЕГРН помогает покупателям быстрее принять решение</UIText1>;
